import { render, staticRenderFns } from "./editUserGuide.vue?vue&type=template&id=afb005b4&scoped=true"
import script from "./editUserGuide.vue?vue&type=script&lang=js"
export * from "./editUserGuide.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afb005b4",
  null
  
)

export default component.exports